export const menuBaseTheme = {
    root: {
        style: {
            display: 'flex',
            fontFamily: 'var(--font-family)',
            flexDirection: 'column',
            borderRadius: 'var(--border-radius-normal)',
            border: '1px solid var(--container-outline)',
            backgroundColor: 'var(--white)',
            boxShadow: 'var(--menu-box-shadow)',
        },
    },
    menuitem: {
        style: {
            display: 'flex',
            alignItems: 'center',
            fontSize: 'var(--font-size-normal)',
            color: 'var(--black-85)',
            cursor: 'pointer',
            height: 'var(--menu-item-height)',
            margin: '0 var(--padding-sm) 0 var(--padding-sm)',
            padding: '0 var(--padding-12) 0 var(--padding-12)',
        },
    },
    separator: {
        style: {
            width: '100%',
            height: '1px',
            backgroundColor: 'var(--container-divider)',
            marginBottom: 'var(--padding-sm)',
        },
    },
    start: {
        style: {
            display: 'flex',
            flexDirection: 'column',
        },
    },
};
